<template>
  <div>
    <div 
      id="modal-assistencia-tecnica" 
      class="w3-animate-zoom w3-modal"
      style="display: block; z-index:110!important; padding:0px!important;"
      v-if="abrir_modal_assistencia_tecnica">

      <div class="w3-modal-content w3-animate-zoom" @click.stop>
        <header class="w3-container">
          <span @click="abrir_modal_assistencia_tecnica = false" class="w3-button w3-display-topright">
            &times;
          </span>

          <h4 class="texto-vermelho w3-center">Dados de assistências técnicas</h4>
          <h3 class="texto-cinza w3-center">
            {{formatarValor(dados_produto.produto_id, 0)}} - {{dados_produto.nome}}
          </h3>
        </header>

        <div class="w3-row-padding">
          <div class="w3-responsive w3-margin-top w3-hide-small w3-hide-medium" style="max-height: calc(75vh - 320px);min-height: 300px;overflow: auto">
            <table class="w3-table-all">

              <thead>
                <tr>
                  <th class="alinhamento-numero">Cadastro</th>
                  <th>Razão social</th>
                  <th>Bairro</th>
                  <th>Cidade</th>
                  <th>Estado</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="assistencia in assistencias_tecnicas" :key="assistencia">
                  <td class="alinhamento-numero">{{assistencia.cadastro_id}}</td>
                    <td>{{assistencia.nome_razao_social}}</td>
                    <td>{{assistencia.nome_bairro}}</td>
                    <td>{{assistencia.nome_cidade}}</td>
                    <td>{{assistencia.estado_id}}</td>
                  </tr>
              </tbody>

            </table>
          </div>

          <div class="w3-hide-large">
            <div class="w3-show card-informacoes" v-for="assistencia in assistencias_tecnicas" :key="assistencia">            
              <div class="w3-col s12 card-item">
                <label>Cadastro: </label>
                <strong>{{assistencia.cadastro_id}}</strong>
              </div>   

              <div class="w3-col s12 card-item">
                <label>Razão social: </label>
                <strong>{{assistencia.nome_razao_social}}</strong>
              </div>     

              <div class="w3-col s12 card-item">
                <label>Bairro: </label>
                <strong>{{assistencia.nome_bairro}}</strong>
              </div>   
              
              <div class="w3-col s12 card-item">
                <label>Cidade: </label>
                <strong>{{assistencia.nome_cidade}}</strong>
              </div>   

              <div class="w3-col s12 card-item">
                <label>Estado: </label>
                <strong>{{assistencia.estado_id}}</strong>
              </div>                                                                                                                                                                                                                                                   
            </div> 

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueNumeric from 'vue-numeric'
import formatarValorMixin from '@/mixins/formatarValorMixin'
import moment from 'moment'
import Legenda from '@/components/Legendas' 
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import RProdutoBuscarAssistenciasTecnicasProduto from '@/components/Rest/RProduto/RProdutoBuscarAssistenciasTecnicasProduto.js'
export default {
  name: 'ModalAssistenciaTecnica',
  components: {
    VueNumeric, Legenda
  },
  mixins:[formatarValorMixin],
  data () {
    return {
      api: process.env.API,
      dados_produto: {},
      assistencias_tecnicas: [],
      abrir_modal_assistencia_tecnica: false,
    }
  },
  methods: {
    async exibirModal(produto){
      this.dados_produto = Object.assign({}, produto);
      this.buscarAssistenciasTecnicas();
    },

    async buscarAssistenciasTecnicas(){
      try {

        let parametros = {
          produto_id: this.dados_produto.produto_id
        }
    
        let retorno = await RProdutoBuscarAssistenciasTecnicasProduto.buscarAssistenciasTecnicasProduto(this.axios, parametros);

        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        this.assistencias_tecnicas = retorno.dados;
        this.abrir_modal_assistencia_tecnica = true;
      } catch (error) {
        this.verificarErro(error, 'buscarAssistenciasTecnicas');
      }
    },
    
    verificarErro(erro, nome_funcao){
      Biblioteca.gerarLogNomeFuncao('ModalCaracteristicasProduto.vue -> ' + nome_funcao);
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },

  },

}
</script>


// WEBPACK FOOTER //
// src/components/Orcamentos/ModalAssistenciaTecnica.vue